import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { Component, inject, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { SsrMarkToUnwrapDirective } from './ssr-markto-unwrap.directive';
import { MAILGUN_BLOCK_SCOPE_MARKER } from '../mailgun/constants';
import type { WrappedValue } from '../mailgun/wrap-value';

type TemplateContext = {
  prop: WrappedValue<any>;
  ok: TemplateRef<any>;
  notOk?: TemplateRef<any>;
};

@Component({
  template: `
    <ng-template #interpolateIf let-prop="prop" let-ok="ok" let-notOk="notOk">
      @if (prop?.isTruthy()) {
        <ng-container *ngTemplateOutlet="ok" />
      } @else {
        <ng-template [ngTemplateOutlet]="notOk ?? empty" />
      }
    </ng-template>

    <ng-template #mailgunIf let-prop="prop" let-ok="ok" let-notOk="notOk"
      ><marker emailSsrMarkToUnwrap [innerHTML]="getMailgunIf(prop)" />
      <ng-container *ngTemplateOutlet="ok" />
      @if (notOk) {
        <marker emailSsrMarkToUnwrap [innerHTML]="getMailgunElse()" />
        <ng-container *ngTemplateOutlet="notOk" />
      }
      <marker emailSsrMarkToUnwrap [innerHTML]="getMailgunIfEnd()" />
    </ng-template>

    <ng-template #empty />
  `,
  hostDirectives: [SsrMarkToUnwrapDirective],
  imports: [NgTemplateOutlet, SsrMarkToUnwrapDirective],
})
export class EmailMailgunIfComponent {
  @ViewChild('interpolateIf', { static: true }) public interpolateIf: TemplateRef<TemplateContext>;
  @ViewChild('mailgunIf', { static: true }) public mailgunIf: TemplateRef<TemplateContext>;

  public sanitizer = inject(DomSanitizer);

  public getMailgunIf(prop: WrappedValue<any>) {
    // eslint-disable-next-line ban/ban
    return this.sanitizer.bypassSecurityTrustHtml(
      `<!-- ${MAILGUN_BLOCK_SCOPE_MARKER}{{#if ${prop.toPath()}}} -->`,
    );
  }

  public getMailgunElse() {
    // eslint-disable-next-line ban/ban
    return this.sanitizer.bypassSecurityTrustHtml(`<!-- ${MAILGUN_BLOCK_SCOPE_MARKER}{{else}} -->`);
  }

  public getMailgunIfEnd() {
    // eslint-disable-next-line ban/ban
    return this.sanitizer.bypassSecurityTrustHtml(`<!-- ${MAILGUN_BLOCK_SCOPE_MARKER}{{/if}} -->`);
  }
}
